import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogContent,
  Button,
 } from '@material-ui/core';
 import { Row, Col } from 'react-flexbox-grid'

const styles = theme => ({
  rootDialog:{
      zIndex: 1250,
  },
  rootPaperScrollPaper:{
    zIndex: 1200,
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '-5px 4px 10px #8E8E8E29',
    borderRadius: '21px',
    opacity: 1,
    padding: '0px !important',
    minWidth: '300px'
},
})

const DatosFacturacionModal = (props) => {
  const {
    classes,
    clienteDatosFacturacion,
    handleOnCerrar,
  } = props;

  const {
    cuit,
    nombreRazonSocial,
    domicilio,
    condicionIVA,
  } = clienteDatosFacturacion;

  const parseCuit = (cuit) => `${cuit.substring(0, 2)}-${cuit.substring(2, 10)}-${cuit.substring(10, 11)}`;

  return (
    <Dialog
      open
      classes={{root: classes.rootDialog, paperScrollPaper: classes.rootPaperScrollPaper}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth='sm'
      fullWidth={true}
    >
      <DialogContent classes={{root: classes.rootPaperScrollPaper}}>

        <Row style={{margin: '0px'}}>

          <Col xs={12} md={12} lg={12}  style={{padding: '0px'}}>
            <div className='containerModalQuitar datosFacturacion'>

              <div className='labelTitleDatosUsuario'>Datos de facturación</div>
              
              <div className='campoInfo'>
                <div className='infoClave'>CUIT:</div>
                <div className='infoValue'>{parseCuit(cuit)}</div>
              </div>

              <div className='campoInfo'>
                <div className='infoClave'>Nombre / Razón social:</div>
                <div className='infoValue'>{nombreRazonSocial}</div>
              </div>

              <div className='campoInfo'>
                <div className='infoClave'>Domicilio:</div>
                <div className='infoValue'>{domicilio}</div>
              </div>

              <div className='campoInfo'>
                <div className='infoClave'>Condicion frente al IVA:</div>
                <div className='infoValue'>{condicionIVA.nombre}</div>
              </div>

              <div className='containerButtonsQuitar'>
                <Button className='cancelarBtn' onClick={handleOnCerrar}>
                  CERRAR
                </Button>
              </div>

            </div>
          </Col>
        </Row>
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(DatosFacturacionModal)
